import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Inject } from '@angular/core';
import * as dropin from 'braintree-web-drop-in';
import { DOCUMENT } from '@angular/common';
import { Observable, Subject, takeUntil, distinctUntilChanged, throttleTime } from 'rxjs';
import { ConfigService } from "../../Services/ConfigService";
import { PaymentService } from '../../Services/Custom/ServicePayment';
import { PaymentSystemEnum } from '../../Models/Interfaces/PaymentSystemEnum';

declare var CardX: any;

@Component({
	selector: 'MakePaymentPartial',
	templateUrl: 'MakePayment.html',

})
export class MakePaymentPartialComponent implements OnInit, OnDestroy {

	protected obsToCloseSubject = new Subject();
	ngOnDestroy() {
		this.obsToCloseSubject.next(null);
		this.obsToCloseSubject.complete();
		this.globalWindow = null;
	}

	globalWindow: any;
	disabled: boolean = false;
	paymentSystem: TooBig4Car.Logic.PublicPaymentSystemInfoVM = {
		PaymentSystem: PaymentSystemEnum.None
	};
	ngOnInit(): void {
		this.setUpSave();
	}

	constructor(
		@Inject(DOCUMENT) private doc: any,
		public configData: ConfigService,
		private myPaymentService: PaymentService,
	) {
		this.globalWindow = window;
		this.globalWindow.paymentCallback = this.runCardXPayment;
		this.globalWindow.paymentCallbackContext = this;
	}

	@Input()
	set payInfo(val: TooBig4Car.Logic.PublicPaymentInfoVM) {
		this.myItem = val;
		if (!this.configData.IsEmptyGuid(this.myItem.PickupDeliveryID)) {
			this.loadItem();
		}
		this.loadCardXScript();
		this.loadSurchargeData();
		if (this.paymentSystem.PaymentSystem != PaymentSystemEnum.None) {
			this.myItem.PaymentSystem = this.paymentSystem.PaymentSystem;
		}
	}
	myItem = {} as TooBig4Car.Logic.PublicPaymentInfoVM;

	@Input()
	buttonText: string = '';

	@Input()
	customerID: System.Guid = '';

	@Output()
	success = new EventEmitter<TooBig4Car.Logic.PublicPaymentInfoVM>();

	@Output()
	error = new EventEmitter();

	@Output()
	progress = new EventEmitter<boolean>();

	validationErrors: string[] = [];

	btInstance: any = null;
	eschHostedTokenization: any = null;
	get showEschelon(): boolean {
		return PaymentSystemEnum.Eschelon == this.paymentSystem?.PaymentSystem;
	}
	get showCardX(): boolean {
		return PaymentSystemEnum.CardX == this.paymentSystem?.PaymentSystem;
	}

	get showBrainTree(): boolean {
		return PaymentSystemEnum.Braintree == this.paymentSystem?.PaymentSystem;
	}

	loadEschelonUI() {
		var inputStyles = 'display: block; padding: .375rem .75rem; font-size: 1rem;line-height: 1.5;';
		inputStyles += 'color: #212529; background-clip: padding-box; border: 1px solid #dee2e6; -webkit-appearance: none; ';
		inputStyles += '-moz-appearance: none;appearance: none;border-radius: .375rem; ';
		const options = {
			target: '#dropin-container',
			//showZip: true,
			styles: {
				card: inputStyles + ' width: 100%;',
				expiryMonth: inputStyles,
				expiryYear: inputStyles,
				cvv2: inputStyles,
				avsZip: inputStyles,
				expiryContainer: 'display: inline-block; float: left;',
				labelType: 'static-top',
				labels: 'font-size: 16px;'
			}
		};
		var thisHolder = this;
		const tokenizationSourceKey = thisHolder.paymentSystem.Token;
		this.eschHostedTokenization = new thisHolder.globalWindow.HostedTokenization(tokenizationSourceKey, options);
		this.disabled = false;
		this.eschHostedTokenization.on('change', (event: any) => {
			if (event?.error) {
				thisHolder.validationErrors.push(event.error.message);
			} else {
				thisHolder.validationErrors = [];
			}
			this.loadSurchargeData();
		});
	}

	surchargeExplanation = '';

	fillSurchargeText(surAmount: number) {
		var total = this.myItem.PaymentAmount;
		var str = '';
		if (surAmount ?? 0 > 0) {
			str += '<br /> + $' + surAmount.toFixed(2) + ' (card fee)';
			total += surAmount;
		}
		if (this.myItem.FuelSurchargeAmount ?? 0 > 0) {
			str += '<br /> + $' + this.myItem.FuelSurchargeAmount.toFixed(2) + ' (fuel surcharge)';
			total += this.myItem.FuelSurchargeAmount;
		}
		if (str) {
			str += ' <br /> = $' + total.toFixed(2);
		}
		return str;
	}

	get totalAmountToPay() {
		var pmtAmt = this.myItem.PaymentAmount ?? 0;
		if (this.myItem.FuelSurchargeAmount ?? 0 > 0) {
			pmtAmt += this.myItem.FuelSurchargeAmount;
		}
		return pmtAmt;
	}
	loadSurchargeData() {
		this.surchargeExplanation = '';
		this.myItem.NonceData = '';
		if (PaymentSystemEnum.Eschelon == this.paymentSystem.PaymentSystem) {
			this.disabled = true;
			this.myItem.SurchargeAmount = 0;
			var errText = ' Surchage calculated after card data is entered';
			if (!this.eschHostedTokenization) {
				this.surchargeExplanation = errText;
				this.loadEschelonUI();
			} else {
				if (this.totalAmountToPay) {
					var sPromise = this.eschHostedTokenization.getSurcharge();
					sPromise.then((sData: any) => {
						if (sData && sData.surcharge?.value) {
							var surAmount = (sData.surcharge?.type === "percent"
								? Math.round(Number(this.totalAmountToPay) * 100 * (sData.surcharge?.value / 100)) / 100
								: sData.surcharge?.value);
							this.myItem.SurchargeAmount = surAmount;
						}
						this.surchargeExplanation = this.fillSurchargeText(surAmount);
						this.disabled = false;
					})
						.catch((error: any) => {
							this.surchargeExplanation = ' + Error Calculating Credit Card Surcharge';
							if (error && error.toString()) {
								this.surchargeExplanation += ' (' + error.toString() + ')';
							}
							this.surchargeExplanation = this.fillSurchargeText(0);
							this.disabled = false;
						});
				}
			}
		} else {
			this.surchargeExplanation = this.fillSurchargeText(0);
		}
	}
	loadEschelonScript() {
		if (PaymentSystemEnum.Eschelon == this.paymentSystem.PaymentSystem) {
			this.disabled = true;
			if (!this.globalWindow.HostedTokenization) {
				let s = this.doc.getElementById('eschelon_script');
				if (!s) {
					s = this.doc.createElement('script');
					s.type = 'text/javascript';
					s.id = "eschelon_script";
					const head = this.doc.getElementsByTagName('head')[0];
					head.appendChild(s);
				}
				s.setAttribute("src", "https://tokenization." + (this.paymentSystem.IsSandbox ? 'sandbox.' : '') + "echelonsecure.app/tokenization/v0.3");
				s.onload = () => {
					if (!this.eschHostedTokenization) {
						this.loadEschelonUI();
					}
				}
			} else {
				if (!this.eschHostedTokenization) {
					this.loadEschelonUI();
				}
			}
		}
	}
	loadCardXScript() {
		if (PaymentSystemEnum.CardX == this.paymentSystem.PaymentSystem) {
			if (this.globalWindow.CardX) {
				this.globalWindow.CardX.closeLightbox();
			}
			let s = this.doc.getElementById('cardx_lightbox_script');
			if (!s) {
				s = this.doc.createElement('script');
				s.type = 'text/javascript';
				s.id = "cardx_lightbox_script";
				s.setAttribute("data-button", "#pay_with_cardx");
				s.setAttribute("data-callback", "paymentCallback");
				s.setAttribute("data-mode", "payment");
				const head = this.doc.getElementsByTagName('head')[0];
				head.appendChild(s);
			}
			s.setAttribute("src", "https://" + (this.paymentSystem.IsSandbox ? 'test.' : '') + "lightbox.cardx.com/v1/lightbox.min.js");
			s.setAttribute("data-account", this.paymentSystem.Account);
			s.setAttribute("data-amount", this.totalAmountToPay);
		}
	}

	tokenLoaded = false;
	loadItem() {
		if (!this.tokenLoaded) {
			var obs: Observable<TooBig4Car.Logic.PublicPaymentSystemInfoVM>;
			if (this.configData.IsEmptyGuid(this.customerID)) {
				obs = this.myPaymentService.getAnonToken();
			} else {
				obs = this.myPaymentService.getCustomerToken(this.customerID);
			}
			obs.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(pmtObj => {
					this.tokenLoaded = true;
					this.paymentSystem = pmtObj;
					this.myItem.PaymentSystem = this.paymentSystem.PaymentSystem;
					switch (this.paymentSystem.PaymentSystem) {
						case PaymentSystemEnum.Eschelon:
							this.loadEschelonScript();
							break;
						case PaymentSystemEnum.CardX:
							this.loadCardXScript();
							break;
						case PaymentSystemEnum.Braintree:
							this.loadBTScript();
							break;
						default:
							this.disabled = true;
							break;
					}
				});
		}
	}

	loadBTScript() {
		var thisholder = this;
		if (!this.btInstance) {
			dropin.create({
				authorization: this.paymentSystem.Token,
				container: '#dropin-container',
			}, function (createErr: any, dropinInstance: any) {
				if (createErr) {
					var errStr = 'Failed: ' + createErr.message + '. Please try again.';
					thisholder.error.emit(errStr);
				} else if (dropinInstance) {
					thisholder.btInstance = dropinInstance;

					if (dropinInstance.isPaymentMethodRequestable()) {
						// This will be true if you generated the client token
						// with a customer ID and there is a saved payment method
						// available to tokenize with that customer.
						thisholder.disabled = false;
					}

					dropinInstance.on('paymentMethodRequestable', function (event: any) {
						console.log(event.type); // The type of Payment Method, e.g 'CreditCard', 'PayPalAccount'.
						console.log(event.paymentMethodIsSelected); // True if a customer has selected a payment method when paymentMethodRequestable fires.
						if (event.paymentMethodIsSelected) {
							thisholder.disabled = false;
						}
					});

					dropinInstance.on('noPaymentMethodRequestable', function () {
						thisholder.disabled = true;
					});
				}
			});
		}
	}
	clearAfterSuccessfulPayment(thisHolder: any) {
		thisHolder.progress.emit(false);
		thisHolder.myItem.PaymentAmount = 0;
		thisHolder.myItem.FuelSurchargeAmount = 0;
		thisHolder.myItem.TipAmount = 0;
		thisHolder.myItem.NonceData = '';
		thisHolder.success.emit(thisHolder.myItem);
	}
	runCardXPayment(err: any, message: any) {
		var globalWindow: any = window;
		var thisHolder = globalWindow.paymentCallbackContext;
		if (!thisHolder.disabled) {
			if (err) {
				thisHolder.error.emit(err);
			} else {

				if ("success" == (message?.pi_response_status ?? "")) {
					thisHolder.myItem.Memo += 'CardX Order ID: ' + (message?.pt_order_id || '');
					thisHolder.progress.emit(true);
					thisHolder.myPaymentService.runPublicPayment('cardx', thisHolder.myItem)
						.subscribe(() => {
							thisHolder.clearAfterSuccessfulPayment(thisHolder);
						},
							(error: any) => {
								thisHolder.error.emit(error);
							});
				} else if ((message?.response ?? "").indexOf('cancelled') >= 0) {
				} else {
					thisHolder.error.emit("Payment Failed");
				}
			}
		} else {
			thisHolder.error.emit("Payment Successful, but there was another error. Please contact our office to let them know.");
		}

	}

	runBTPayment(thisHolder: any) {
		if (this.showBrainTree) {
			if (this.btInstance) {
				this.btInstance.requestPaymentMethod(function (err: any, payload: any) {
					if (payload.nonce) {
						thisHolder.progress.emit(true);
						thisHolder.myPaymentService.runPublicPayment(payload.nonce, thisHolder.myItem)

							.subscribe((pmt: any) => {
								thisHolder.clearAfterSuccessfulPayment(thisHolder);

							},
								(error: any) => {
									thisHolder.error.emit(error);
								});
					}
				});
			}
		}
	}

	runEschelonPayment = async (thisHolder: any) => {
		if (thisHolder.showEschelon) {
			thisHolder.eschHostedTokenization.getData().then(async (event: any) => {
				if (event?.error) {
					thisHolder.validationErrors.push(event.error.message);
				} else {
					thisHolder.validationErrors = [];
					thisHolder.progress.emit(true);
					if (thisHolder.myItem.NonceData) {
						thisHolder.myPaymentService.runPublicPayment('eschelon', thisHolder.myItem)
							.subscribe((pmt: any) => {
								thisHolder.clearAfterSuccessfulPayment(thisHolder);
							},
								(error: any) => {
									thisHolder.error.emit(error);
									thisHolder.myItem.NonceData = '';
								});
					} else {
						await thisHolder.eschHostedTokenization.getNonceToken().then((eshToken: string) => {

							thisHolder.myItem.NonceData = JSON.stringify(eshToken);
							thisHolder.myPaymentService.runPublicPayment('eschelon', thisHolder.myItem)
								.subscribe((pmt: any) => {
									thisHolder.clearAfterSuccessfulPayment(thisHolder);
								},
									(error: any) => {
										thisHolder.error.emit(error);
										thisHolder.myItem.NonceData = '';
									});

						}).catch((error: any) => {
							thisHolder.validationErrors.push(error.message);
							thisHolder.myItem.NonceData = '';
						});
					}
				}
			});
		}
	}

	saveEmitter: EventEmitter<any> = new EventEmitter<any>();
	setUpSave() {
		var thisHolder = this;
		thisHolder.saveEmitter.asObservable()
			.pipe(
				//distinctUntilChanged(),
				throttleTime(300),
			)
			.subscribe(async () => {
				if (!thisHolder.disabled) {
					if (thisHolder.showBrainTree) {
						thisHolder.runBTPayment(thisHolder);
					} else if (thisHolder.showEschelon) {
						await thisHolder.runEschelonPayment(thisHolder);
					} else {
						thisHolder.error.emit('Failed to run payment.');
					}

				}
			});
	}
	runPayment () {
		this.saveEmitter.next(this);
	}
}
